/*
 * The API's base path (docs/API.md). A leaf module on its own: the console's fetch store
 * re-exports it, and the screen player's bundle (`src/player/`) reads it from here without
 * pulling in the console's stores and router.
 */
export const API_BASE_URL = '/api/signage-api/v1'
